import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

/**
 * KpiCards — 4 KPI cliccabili sotto la greeting.
 * summary shape: { kpis: {open_tickets, scadenze_7d, docs_needs_review, meetings_today} }
 * Ogni KPI: { value: number|null, linkable: bool, href: string|null, skipped?: bool }
 */
const CARDS = [
    { key: "open_tickets",     label: "Ticket aperti" },
    { key: "scadenze_7d",      label: "Scadenze 7gg" },
    { key: "docs_needs_review", label: "Documenti da verificare" },
    { key: "meetings_today",   label: "Riunioni oggi" },
];

export default function KpiCards({ summary }) {
    const nav = useNavigate();
    const kpis = summary?.kpis || {};
    return (
        <div className="enl-kpi-grid" data-testid="kpi-grid">
            {CARDS.map((c) => {
                const d = kpis[c.key] || {};
                const skipped = !!d.skipped;
                const value = d.value;
                const displayValue =
                    skipped || value == null ? "—" : String(value);
                const disabled = skipped || !d.linkable;
                const onActivate = () => {
                    if (disabled || !d.href) return;
                    nav(d.href);
                };
                return (
                    <a
                        key={c.key}
                        href={d.href || "#"}
                        role={disabled ? "presentation" : "button"}
                        tabIndex={disabled ? -1 : 0}
                        aria-disabled={disabled}
                        aria-label={c.label}
                        className={`enl-kpi ${disabled ? "is-disabled" : ""}`}
                        data-testid={`kpi-${c.key}`}
                        data-skipped={skipped ? "true" : "false"}
                        onClick={(e) => {
                            e.preventDefault();
                            onActivate();
                        }}
                        onKeyDown={(e) => {
                            if (!disabled && (e.key === "Enter" || e.key === " ")) {
                                e.preventDefault();
                                onActivate();
                            }
                        }}
                    >
                        <ArrowUpRight size={16} className="arrow" aria-hidden />
                        <div className={`value ${displayValue === "—" ? "dim" : ""}`}
                             data-testid={`kpi-${c.key}-value`}>
                            {displayValue}
                        </div>
                        <div className="label">{c.label}</div>
                    </a>
                );
            })}
        </div>
    );
}
